import { ArticleDetailTranslation } from 'locales/de/pages/articleDetail';

const en: ArticleDetailTranslation = {
  articleBy: 'written by {{author}}{{department}} on {{date}}',
  deleteConfirm: {
    title: 'Confirm delete',
    message: 'You are about to delete this article. Are you really sure?'
  },
  deleteSuccessful: 'Article successfully deleted',
  deleteFailed: 'The article could not be deleted',
  notificationSuccessful: 'The recipients were successfully informed',
  notificationFailed: 'The recipients could not be informed',
  openFailed: 'Article could not be opened',
  sendEmail: 'Emergency notification',
  confirmSendEmail: 'Actual urgent notification?',
  confirmSendEmailDetail:
    'Use this function *only in really urgent cases*, as the recipients\nwill be informed about this post by e-mail tomorrow anyway.\n*Really send e-mail and push-notification?*.',
  notFound: 'Article could not be found',
  errorLoading: 'Article could not be loaded.',
  goToEvent: 'To Registration'
};

export default en;
